var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loadingAction } },
    [
      _vm.selectedBatches.length > 1
        ? _c(
            "b-dropdown",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED185",
                  expression: "'ED185'"
                }
              ],
              attrs: {
                variant: "link",
                "no-caret": "",
                "data-cy": "massive-actions",
                right: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c("feather-icon", {
                          staticClass: "mr-3",
                          attrs: { icon: "ApertureIcon" }
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v("Acciones")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                609182883
              )
            },
            [
              _c(
                "CheckPermission",
                { attrs: { permission: "ED172" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-cancel" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchCancel()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "highlight_off" } }),
                      _vm._v(" Anular ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED169" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-validate" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchValidate()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "verified_user" } }),
                      _vm._v(" Validar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED167" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-approve" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchApprove()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "thumb_up" } }),
                      _vm._v(" Aprobar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED186" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-reject" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchReject()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "thumb_down" } }),
                      _vm._v(" Rechazar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED173" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-add-auction" },
                      on: { click: _vm.onOptionBatchPostule }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "add_circle" } }),
                      _vm._v(" Agregar a subasta ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED225" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-donate" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchDonate()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "store" } }),
                      _vm._v(" Donar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED226" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-destroy" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionBatchDestroy()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "delete" } }),
                      _vm._v(" Destruir ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "batches-cancel",
                  attrs: {
                    id: "batches-cancel",
                    title: "Anular Lotes",
                    "hide-footer": ""
                  }
                },
                [
                  _c("BatchesCancel", {
                    attrs: { batches: _vm.selectedBatches },
                    on: { cancel: _vm.handleOnCancel }
                  })
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "batches-reject",
                  attrs: {
                    id: "batches-reject",
                    title: "Rechazar Lotes",
                    "hide-footer": ""
                  }
                },
                [
                  _c("BatchesReject", {
                    attrs: { batches: _vm.selectedBatches },
                    on: { reject: _vm.handleOnReject }
                  })
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "batches-approve",
                  attrs: {
                    id: "batches-approve",
                    title: "Aprobar Lotes",
                    "hide-footer": ""
                  }
                },
                [
                  _c("BatchesApprove", {
                    attrs: { batches: _vm.selectedBatches },
                    on: { approve: _vm.handleOnApprove }
                  })
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "batches-postule",
                  attrs: {
                    id: "batches-postule",
                    title:
                      "Agregar " +
                      _vm.selectedBatchesIds.length +
                      " Lotes a Subasta",
                    "no-close-on-backdrop": "",
                    size: "xl",
                    "hide-footer": ""
                  }
                },
                [
                  _c("BatchPostule", {
                    attrs: { "batch-ids": _vm.selectedBatchesIds },
                    on: { postule: _vm.handleOnPostule }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }